import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { Fragment } from "react/jsx-runtime";

import { DeleteTaskPropInterface } from "./DeleteTask";

import { deleteTask } from "@/api";
import { AlertDialog } from "@/components/AlertDialog";

export const DeleteTask: React.FC<DeleteTaskPropInterface> = ({ taskId, refetchTableData }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const openDialogue = () => setOpenDialog(true);
  const closeDialogue = () => setOpenDialog(false);

  const { mutate, isPending } =
    useMutation({
      mutationFn: async () => deleteTask(taskId),
      onSuccess: () => {
        refetchTableData();
        closeDialogue();
      },
    });

  return (
    <Fragment>
      <IconButton
        color="primary"
        size="small"
        onClick={openDialogue}
      >
        <DeleteIcon />
      </IconButton>
      <AlertDialog
        onAccept={mutate}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        dialogTitle="Confirm Deletion"
        isLoading={isPending}
      >
        Are you sure you want to delete the selected task?
      </AlertDialog>
    </Fragment>
  );
};
